import { useContext } from "react";
import { TourBookingContext } from "./TourBookingProvider";

export const useTourBookingContext = () => {
    const context = useContext(TourBookingContext);
    if (context === undefined) {
      throw new Error('useTourBookingContext must be used within a TourBookingProvider');
    }
    return context;
  };